import { render, staticRenderFns } from "./RegistrationData.vue?vue&type=template&id=f38839da&"
import script from "./RegistrationData.vue?vue&type=script&lang=js&"
export * from "./RegistrationData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports